export default __webpack_public_path__ + "static/media/Factory.9bdb8ea0.svg";